<template>
    <div v-on:contextmenu.prevent>
        <v-form ref="form" v-model="isValid" v-bind="$attrs">
            <v-data-table
                v-model="sampleSelection"
                @update:modelValue="updateSampleEditSelection"
                :headers="headers"
                :items="sampleArray"
                item-key="id"
                disable-pagination
                class="elevation-1"
                no-data-text="Select a condition or rep on the left and click add to create new samples"
                show-select
                multi-select
                return-object
            >
                <template v-slot:top="{}">
                    <div class="pa-2">
                        <v-btn @click="clearSamples" variant="text" class="text-red"> Clear </v-btn>
                    </div>
                </template>

                <template v-slot:item.protocols="{ item }">
                    <span>{{ commaSeparate(item.protocols) }}</span>
                </template>

                <template v-slot:item.subwell="{ item }">
                    <p style="white-space: pre" class="ma-0">{{ objToRows(item.subwell) }}</p>
                </template>

                <template v-slot:item.collectionDate="{ item }">
                    {{
                        item.collectionDate
                            ? new Date(item.collectionDate).toISOString().split("T")[0]
                            : ""
                    }}
                </template>
            </v-data-table>
        </v-form>
    </div>
</template>

<script>
import { defineComponent, nextTick } from "vue";

import { mapActions, mapGetters } from "vuex";
import { EventBus } from "../../lib/event-bus";
import _ from "lodash";

export default defineComponent({
    name: "TubeSeries",

    computed: {
        ...mapGetters("plateCreate", ["layout", "sampleDescriptors", "sampleTypes"]),
        sampleArray: function () {
            if (this.$refs.form) {
                this.$refs.form.validate();
            }
            const samples = this.layout[0];
            // Extract descriptor text for table display
            samples.forEach((sample) => {
                sample.sampleDescriptorText = sample.sampleDescriptor
                    ? sample.sampleDescriptor.name
                    : null;
                sample.id = sample.condition.id;
                sample.entityKeyText =
                    sample.entityKey && sample.entityKey.length > 0
                        ? sample.entityKey.map((key) => key.name).join(", ")
                        : null;
            });
            return this.layout[0];
        },
        rules() {
            return [(v) => (v ? true : "Sample Type is required")];
        },
    },

    created() {
        EventBus.$on("clear_sample_selection", this.clearSampleSelection);
    },

    beforeUnmount() {
        EventBus.$off("clear_sample_selection", this.clearSampleSelection);
    },

    data() {
        return {
            sampleSelection: [],
            headers: [
                {
                    title: "Name",
                    value: "condition.name",
                },
                {
                    title: "SAMP Id",
                    value: "condition.samp",
                },
                {
                    title: "Protocol(s)",
                    value: "protocols",
                },
                {
                    title: "Material Type",
                    value: "sampleType.name",
                },
                {
                    title: "Sample Descriptor",
                    value: "sampleDescriptorText",
                },
                {
                    title: "Target Agent(s)",
                    value: "entityKeyText",
                },
                {
                    title: "Subwell",
                    value: "subwell",
                },
                {
                    title: "Notes",
                    value: "note",
                },
                {
                    title: "Collection Date",
                    value: "collectionDate",
                },
            ],
            isValid: false,
        };
    },

    methods: {
        ...mapActions("plateCreate", [
            "addSample",
            "clearSamples",
            "removeSample",
            "setSampleEditSelection",
        ]),
        add() {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const self = this;
            return function (event) {
                self.addSample();
            };
        },
        commaSeparate(protocolArray) {
            const names = _.map(protocolArray, "protocol_id");
            return names.join(", ");
        },
        objToRows(subwellObj) {
            if (subwellObj) {
                let subwellText = [];
                for (let [key, value] of Object.entries(subwellObj)) {
                    subwellText.push(`${key} ${value}`);
                }
                return subwellText.join("\n");
            }
            return null;
        },
        clearSampleSelection() {
            this.sampleSelection = [];
        },
        validate() {
            this.$refs.form.validate();
        },
        updateSampleEditSelection(items) {
            this.sampleSelection = [...items];
            this.setSampleEditSelection(items);
        },
    },
});
</script>

<style scoped>
.flex-container {
    display: flex;
    flex-wrap: wrap;
    margin: 10px;
}

.flex-container > div {
    width: 75px;
    margin: 10px;
    text-align: center;
}
</style>
